import { Controller } from '@hotwired/stimulus'
import Cookies from 'js-cookie'
import uniq from 'lodash.uniq'

export default class extends Controller {
  static targets = ['facility']

  connect () {
    const ids = JSON.parse(Cookies.get('check_nursing_facility_ids') || '[]')
    if (Array.isArray(ids) && ids.indexOf(this.facilityId()) !== -1) { this.element.classList.add(`${this.className()}::bookmarked`) }
  }

  facilityId () {
    return parseInt(this.element.dataset.facilityid)
  }

  className () {
    return this.element.dataset.classname
  }

  add (e) {
    const id = Number(this.element.dataset.facilityid)
    const ids = JSON.parse(Cookies.get('check_nursing_facility_ids') || '[]')
    if (!ids.includes(id)) ids.push(id)
    Cookies.set('check_nursing_facility_ids', JSON.stringify(uniq(ids)))

    this.element.classList.add(`${this.className()}::bookmarked`)

    this.showHeart(e)
  }

  remove () {
    const id = Number(this.element.dataset.facilityid)
    const ids = JSON.parse(Cookies.get('check_nursing_facility_ids') || '[]')
    const index = ids.indexOf(id)
    if (index !== -1) ids.splice(index, 1)
    Cookies.set('check_nursing_facility_ids', JSON.stringify(uniq(ids)))

    this.element.classList.remove(`${this.className()}::bookmarked`)
  }

  showHeart (e) {
    const heart = document.createElement('span')
    heart.classList.add(`${this.className()}::heart-float-up`)

    const container = this.element
    if (getComputedStyle(container).position === 'static') {
      container.style.position = 'relative'
    }
    container.appendChild(heart)

    const rect = container.getBoundingClientRect()
    const localX = e.clientX - rect.left
    const localY = e.clientY - rect.top

    heart.style.position = 'absolute'
    heart.style.left = `${localX}px`
    heart.style.top = `${localY}px`
    heart.style.pointerEvents = 'none'

    const remove = () => heart.remove()
    heart.addEventListener('animationend', remove, { once: true })
    setTimeout(remove, 1500)
  }
}
